import { Button, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useDomain } from '../../hooks/useDomain';
import { getTheme } from '../../stores/selectors/theme.selector';
import { ROUTES } from '../../types/routes.enum';
import { BackButtonHeader } from '../ui-components/back-button-header.component';
import { CancelButton } from '../ui-components/button/cancelButton';
import { ViewWrapper } from '../ui-components/view-wrapper.component';
import { useStyles } from './styles';
import { showSnackBar } from '../../util/toast.utility';

const Logout = () => {
  const classes = useStyles();
  const theme = useSelector(getTheme);
  const navigate = useNavigate();
  const location = useLocation();
  const chargerName = new URLSearchParams(location.search).get('charger');
  const { i18n } = useTranslation();
  const auth = useAuth();
  const { domain } = useDomain();
  const signout = () => {
    try {
      const redirectRoute = chargerName
        ? `/app/${domain}/${ROUTES.LOGIN}?charger=${chargerName}`
        : `/app/${domain}/${ROUTES.LOGIN}`;
      auth.signOut(redirectRoute);
    } catch (error) {
      showSnackBar(i18n.t('unknown_error'));
    }
  };

  const backAction = () => {
    const route = chargerName
      ? `/app/${domain}/${ROUTES.ACCOUNT}?charger=${chargerName}`
      : `/app/${domain}/${ROUTES.ACCOUNT}`;
    navigate(route);
  };

  return (
    <ViewWrapper>
      <Grid className={classes.logoutWrapper}>
        <BackButtonHeader title={`${i18n.t('log_out')}?`} onBackArrowClicked={backAction} />
        <Grid className={classes.container}>
          <Typography className={classes.title} variant='h5' component='h1'>
            {i18n.t('confirm_logout')}
          </Typography>
          <Typography className={classes.subTitle} variant='subtitle1'>
            {i18n.t('confirm_logout_description')}
          </Typography>
        </Grid>
        <Grid container className={classes.root} spacing={1}>
          <Grid item xs={6}>
            <CancelButton onClick={backAction}>{i18n.t('cancel')}</CancelButton>
          </Grid>
          <Grid item xs={6}>
            <Button
              className={classes.buttonItem}
              // style={{}}
              sx={{
                height: '48px',
                backgroundColor: theme.secondary,
                color: theme.primary,
                fontFamily: 'Inter',
                fontStyle: 'normal',
                fontWeight: 600,
                fontSize: '16px',
                ':hover': {
                  backgroundColor: '#BBE7F6',
                },
              }}
              onClick={signout}
            >
              {i18n.t('log_out')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </ViewWrapper>
  );
};

export default Logout;
